module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('f7-list', {
    attrs: {
      "media-list": ""
    }
  }, _vm._l((_vm.remindSettings), function(remindSetting) {
    return _c('li', {
      staticClass: "item-content",
      on: {
        "click": function($event) {
          return _vm.editRemindSetting(remindSetting)
        }
      }
    }, [_c('div', {
      staticClass: "item-media"
    }, [_c('i', {
      staticClass: "icon list-icon icon-alarmclock"
    })]), _vm._v(" "), _c('div', {
      staticClass: "item-inner"
    }, [_c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(remindSetting.label))])])])])
  }), 0)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b81e86b4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b81e86b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/settings/CMRemindSettingList.vue
// module id = 1711
// module chunks = 2